module.exports = __webpack_public_path__ + "static/pivonuv-beh-2021-04-4fdfd14133b248606a64434dd589e0e5.jpg";